module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "sigilnotintoc"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('ul', {
    staticClass: "TOC"
  }, [_c('li', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0005.htm#CHAPTER_I"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("From Mobilisation to the East")])])]), _vm._v(" "), _c('li', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0006.htm#CHAPTER_II"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Gallipoli—to 11th July, 1915")])])]), _vm._v(" "), _c('li', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0007.htm#CHAPTER_III"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Gallipoli")]), _vm._v(" ("), _c('i', {
    staticClass: "calibre7"
  }, [_vm._v("contd.")]), _vm._v(")—"), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("Operations 12th-18th July, 1915")])])]), _vm._v(" "), _c('li', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0008.htm#CHAPTER_IV"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Gallipoli")]), _vm._v(" ("), _c('i', {
    staticClass: "calibre7"
  }, [_vm._v("contd.")]), _vm._v(")")])]), _vm._v(" "), _c('li', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0009.htm#CHAPTER_V"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Gallipoli")]), _vm._v(" ("), _c('i', {
    staticClass: "calibre7"
  }, [_vm._v("concluded")]), _vm._v(")")])]), _vm._v(" "), _c('li', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0010.htm#CHAPTER_VI"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Mudros, Cairo, Suez Canal and Hill 70 Line")])])]), _vm._v(" "), _c('li', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0011.htm#CHAPTER_VII"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Sinai Desert, Mahamdiya, Romani, Katia")])])]), _vm._v(" "), _c('li', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0012.htm#CHAPTER_VIII"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Across the Sinai Desert to El Arish")])])]), _vm._v(" "), _c('li', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0013.htm#CHAPTER_IX"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("El Arish and First Battle of Gaza")])])]), _vm._v(" "), _c('li', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0014.htm#CHAPTER_X"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Second Battle of Gaza")])])]), _vm._v(" "), _c('li', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0015.htm#CHAPTER_XI"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Gaza, 1st May To 7th November, 1917")])])]), _vm._v(" "), _c('li', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0016.htm#CHAPTER_XII"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Advance beyond Gaza. Wadi Hesi, Sausage Ridge,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\n    Esdud, Kubeibeh, Nebi Samwil, Tahta")])])]), _vm._v(" "), _c('li', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0017.htm#CHAPTER_XIII"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("From Tahta to the Auja")])])]), _vm._v(" "), _c('li', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0018.htm#CHAPTER_XIV"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Last Days in Palestine. North of Jaffa")])])]), _vm._v(" "), _c('li', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0019.htm#CHAPTER_XV"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("France")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "sigilnotintoc sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00007"
    }
  }, [_c('a', {
    staticClass: "calibre8",
    attrs: {
      "href": "#/Text/Section0020.htm#APPENDICES"
    }
  }, [_vm._v("APPENDICES")])]), _vm._v(" "), _c('ul', {
    staticClass: "TOC"
  }, [_c('li', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0020.htm#APPENDIX_I"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("List of Officers, Senior N.C.O.'s, etc., who embarked in"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\n    May, 1915")])])]), _vm._v(" "), _c('li', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0021.htm#APPENDIX_II"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Roll of Officers, Warrant Officers, Non-Commissioned"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\n    Officers and Men who died on Service")])])]), _vm._v(" "), _c('li', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0022.htm#APPENDIX_III"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Honours and Awards")])])]), _vm._v(" "), _c('li', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0023.htm#APPENDIX_IV"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Turkish Orders for Advance on Romani")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a61bab10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0003.vue
// module id = 63
// module chunks = 0